var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoArchive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_archive",
    d: "M488.141,482.754h0a1.3,1.3,0,0,0-.962-.426h-.539l.179-1.477a1.655,1.655,0,0,0-.246-1.091,1.184,1.184,0,0,0-.98-.555H473.3a1.169,1.169,0,0,0-.958.563,1.627,1.627,0,0,0-.246,1.087l.178,1.472h-.562a1.3,1.3,0,0,0-.964.427,1.172,1.172,0,0,0-.294.932l.915,9.115a1.669,1.669,0,0,0,1.645,1.4H485.9a1.625,1.625,0,0,0,1.627-1.448l.911-9.056A1.183,1.183,0,0,0,488.141,482.754Zm-13.847-1.16h10.325l-.089.733H474.383Zm11.92,2.8-.778,7.732h-11.98l-.783-7.732Zm-3.686,1.468h-6.166a.726.726,0,0,0,0,1.452h6.166a.726.726,0,0,0,0-1.452Z",
    transform: "translate(-470.444 -479.204)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoArchive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_archive.4fe38eb1639c5c82b0bc3b0007c626a0.svg";